"use client";

import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Register ScrollTrigger securely
if (typeof window !== "undefined") {
    gsap.registerPlugin(ScrollTrigger);
}

interface RevealProps {
    children: React.ReactNode;
    width?: "fit-content" | "100%";
    className?: string;
    delay?: number;
}

export function Reveal({ children, width = "fit-content", className = "", delay = 0.25 }: RevealProps) {
    const ref = useRef<HTMLDivElement>(null);

    useGSAP(() => {
        const element = ref.current;
        if (!element) return;

        gsap.killTweensOf(element.children);

        gsap.fromTo(element,
            { opacity: 0, y: 75 },
            {
                opacity: 1,
                y: 0,
                duration: 0.8,
                delay: delay,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: element,
                    start: "top 85%",
                    toggleActions: "play none none none"
                }
            }
        );
    }, { scope: ref });

    return (
        <div ref={ref} style={{ position: "relative", width, opacity: 0 }} className={className}>
            {children}
        </div>
    );
}
